<template>
  <image-viewer
    :z-index="9999"
    :initial-index="firstOne"
    v-if="showViewer"
    :on-close="closeViewer"
    :url-list="urlList"
  /> 
</template>

<script>
import ImageViewer from "element-ui/packages/image/src/image-viewer.vue";
export default {
  props: {
    show: {},
    urlList: {},
  },
  components: {
    ImageViewer,
  },
  data() {
    return {
      showViewer: this.show,
      prevOverflow: "",
      firstOne: 0,
    };
  },
  watch: {
    show(val) {
      this.showViewer = val;
      if (!val) {
        return;
      }
      this.firstOne = 0;
      this.prevOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    },
  },
  methods: {
    closeViewer() {
      document.body.style.overflow = this.prevOverflow;
      this.showViewer = false;
      this.$emit("update:show", false);
      this.$hideImages()
    },
  },
};
</script>

<style>
</style>